<script>
import axios from "axios";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
  name: "form-detail",
  props: ["idPembelajaran", "statusUnggahUndangan"],
  data() {
    return {
      axiosCatchError: null,
      status_unggah: this.statusUnggahUndangan,
      status_file: false,
      file_undangan_default: "#",
      file_undangan_instruktur: "#",
      file_undangan: null,
    };
  },
  mounted() {
    // get data pembelajaran
    let self = this;
    Swal.fire({
      title: '<i class="fas fa-spinner fa-spin"></i>',
      text: "Loading...",
      showConfirmButton: false,
    });

    var config = {
      method: "get",
      url:
        process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pembelajaran",
      params: {
        id: this.idPembelajaran,
      },
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.access_token,
      },
    };
    axios(config)
      .then(function (response) {
        var response_data = response.data;
        var response_data_fix = response_data.data;
        if (response_data.meta.code == 200) {
          var data_edit = response_data_fix.data_pembelajaran;
          if (self.status_unggah == "peserta") {
            if (data_edit.pbl_file_undangan) {
              self.file_undangan_default =
                process.env.VUE_APP_BACKEND_URL + data_edit.pbl_file_undangan;
              self.status_file = true;
            }
          } else {
            if (data_edit.pbl_file_undangan_instruktur) {
              self.file_undangan_instruktur =
                process.env.VUE_APP_BACKEND_URL +
                data_edit.pbl_file_undangan_instruktur;
              self.status_file = true;
            }
          }
          Swal.close();
        } else {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data_fix.data.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        Swal.close();
      });
  },
  methods: {
    inputFilePdf() {
      let self = this;
      if ($("#formPdf")[0].files[0]) {
        if ($("#formPdf")[0].files[0].size < 2242880) {
          if ($("#formPdf")[0].files[0].type == "application/pdf") {
            $("#uploadLoadingPdf").html(
              '<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>'
            );
            var urlres = process.env.VUE_APP_BACKEND_URL;
            var FormData = require("form-data");
            var data = new FormData();
            data.append("file", $("#formPdf")[0].files[0]);
            var config = {
              method: "post",
              url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
              headers: {
                Authorization: "Bearer " + localStorage.access_token,
              },
              data: data,
            };
            axios(config).then(function (response) {
              console.log(response.data.data.path_file);
              var path_file = response.data.data.path_file;
              urlres += path_file;
              $("#uploadLoadingPdf").html(
                '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                  urlres +
                  '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
              );
              self.file_undangan = path_file;
            });
          } else {
            alert("Tipe File Wajib PDF.");
          }
        } else {
          alert("Max File 2 MB");
        }
      }
    },
    StoreDataUndangan() {
      let self = this;
      Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
      });

      var config_store_data = {
        method: "put",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          "transactions/pra-pelaksanaan/unggah-undangan",
        data: {
          id: this.idPembelajaran,
          path_pdf: self.file_undangan,
          user_id: localStorage.getItem("session_user_id"),
          status_unggah: self.status_unggah,
        },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config_store_data)
        .then(function (response) {
          console.log(response);
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text: "Data Undangan Berhasil Disimpan.",
            timer: 2000,
            timerProgressBar: true,
            showCancelButton: false,
            showConfirmButton: false,
          }).then((result) => {
            /* Read more about handling dismissals below */
            if (result.dismiss === Swal.DismissReason.timer) {
              self.$emit("close-form-undangan");
            }
          });
        })
        .catch(function (error) {
          self.axiosCatchErrorProfile = error.response.data.data;
          Swal.close();
        });
    },
  },
};
</script>

<template>
  <b-form class="p-2" @submit.prevent="StoreDataUndangan">
    <div class="row">
      <div class="col-12">
        <div v-if="axiosCatchError">
          <div
            class="alert alert-danger"
            v-if="
              typeof axiosCatchError === 'string' ||
              axiosCatchError instanceof String
            "
          >
            {{ axiosCatchError }}
          </div>
          <div class="alert alert-danger" role="alert" v-else>
            <div v-for="(errorArray, idx) in axiosCatchError" :key="idx">
              <div v-for="(allErrors, idx) in errorArray" :key="idx">
                <span class="text-danger">{{ allErrors[0] }} </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="mb-3">
          <label for="formPdf" class="form-label">Pilih File PDF</label>
          <input
            class="form-control"
            type="file"
            id="formPdf"
            v-on:change="inputFilePdf()"
          />
          <div
            class="respond-input-file float-left"
            id="uploadLoadingPdf"
          ></div>
          <small class="float-right" style="color: red"
            >*) Max File 2 MB & File Wajib PDF</small
          >
        </div>
      </div>
      <div class="col-12">
        <div v-if="status_unggah == 'peserta'">
          <div v-if="status_file == true">
            <a
              v-bind:href="file_undangan_default"
              target="_blank"
              role="button"
              class="btn btn-sm btn-info"
            >
              <i class="fa fa-file-pdf"></i> Lihat File Undangan Yang Telah
              Terunggah
            </a>
          </div>
        </div>
        <div v-else>
          <div v-if="status_file == true">
            <a
              v-bind:href="file_undangan_instruktur"
              target="_blank"
              role="button"
              class="btn btn-sm btn-info"
            >
              <i class="fa fa-file-pdf"></i> Lihat File Undangan Yang Telah
              Terunggah
            </a>
          </div>
        </div>
        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">&nbsp;</div>
      <div class="col-md-6">
        <div class="text-end">
          <b-button type="reset" variant="danger">
            <i class="fa fa-redo-alt"></i> Reset
          </b-button>
          &nbsp;
          <b-button type="submit" variant="primary">
            <i class="fa fa-save"></i> Simpan
          </b-button>
        </div>
      </div>
    </div>
  </b-form>
</template>
